import { render } from "./Impostazioni.vue?vue&type=template&id=0c56cd37&scoped=true"
import script from "./Impostazioni.vue?vue&type=script&lang=js"
export * from "./Impostazioni.vue?vue&type=script&lang=js"

import "./Impostazioni.vue?vue&type=style&index=0&id=0c56cd37&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c56cd37"]])

export default __exports__